@for (answer of answerList; track answer) {
  <div class="pt-2">
    <div [innerHTML]="answer"></div>
  </div>
}
